export default "__VITE_ASSET__HV6b6z81kKhR47in7kWQhA__"